/**
 * Created by piotr.pozniak@thebeaverhead.com on 20/10/2022.
 */
import { useIntegrationsStore } from "../../../../../hooks/redux/integrations";
import { IntegrationStatus } from "../../../consts/integrations";

const ERROR_STATUSES = [
  IntegrationStatus.syncError,
  IntegrationStatus.reAuthRequired,
  IntegrationStatus.permissionsRevoked,
];

const BODY_MAX = 90;
const truncate = (text) =>
  text && text.length > BODY_MAX ? `${text.slice(0, BODY_MAX - 1)}…` : text;

/**
 * One alert per broken integration — can return more than one candidate;
 * SidebarAlerts's global cap (two, across all producers) still applies.
 * @returns {SidebarAlert[]}
 */
export function useSyncIssuesAlerts() {
  const { integrations } = useIntegrationsStore();

  return integrations.collection
    .filter((i) => ERROR_STATUSES.includes(i.status) && i.available)
    .map((integration) => {
      // IntegrationsPage.js's deep-link contract: ?settings=<uuid> opens
      // the Settings dialog (Scopes tab when the reason is permissions),
      // ?reauth=<uuid> skips the dialog and goes straight to the provider.
      if (integration.status === IntegrationStatus.permissionsRevoked) {
        return {
          id: `syncIssue-${integration.uuid}`,
          variant: "critical",
          icon: "AlertCircle",
          title: `${integration.name} access revoked`,
          body: "Grant the missing permissions to resume syncing.",
          action: {
            label: "Review permissions",
            to: `/integrations?settings=${integration.uuid}&reason=permissions`,
          },
        };
      }

      if (integration.status === IntegrationStatus.reAuthRequired) {
        return {
          id: `syncIssue-${integration.uuid}`,
          variant: "warning",
          icon: "AlertTriangle",
          title: `${integration.name} needs attention`,
          body: "Access expired. New item aren't syncing.",
          action: {
            label: "Reconnect",
            to: `/integrations?reauth=${integration.uuid}`,
          },
        };
      }

      // syncError
      return {
        id: `syncIssue-${integration.uuid}`,
        variant: "warning",
        icon: "AlertTriangle",
        title: `${integration.name} sync failed`,
        body:
          truncate(integration.last_error_message) ||
          "The last sync didn't complete.",
        action: {
          label: "Take a look",
          to: `/integrations?settings=${integration.uuid}`,
        },
      };
    });
}

export default useSyncIssuesAlerts;
